module.exports = __webpack_public_path__ + "static/media/IshikaBhattacharjee.fd3944d9.png";